export default "__VITE_ASSET__CDf3oRC9__"